import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
import { WaveDivider } from './ui/WaveDivider';
export function GuaranteeSection() {
  return <section className="relative bg-cream pt-20 pb-24 overflow-hidden" data-id="element-92">
      {/* Top Divider - transitioning from FAQ (white) to Guarantee (cream) */}
      <div className="absolute top-0 left-0 w-full" data-id="element-93">
        <WaveDivider fill="#ffffff" position="top" className="-mt-[1px]" data-id="element-94" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center mt-8" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-96">
          <ShieldCheck className="w-20 h-20 text-gold mx-auto mb-6" strokeWidth={1.5} data-id="element-97" />

          <span className="inline-block text-gold font-bold tracking-widest uppercase text-sm mb-4" data-id="element-98">
            100% MONEY BACK
          </span>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-deep-teal mb-8 leading-tight" data-id="element-99">
            The First Night Guarantee —<br className="hidden md:block" data-id="element-100" /> 30
            Days, Zero Risk
          </h2>

          <div className="max-w-2xl mx-auto space-y-6 text-lg text-gray-700 leading-relaxed mb-12" data-id="element-101">
            <p data-id="element-102">
              Apply the 7-Minute Cooling Protocol tonight. If you don't wake up
              feeling noticeably different in the next 30 days — less bloated,
              calmer, more rested — email us and we'll refund every cent. No
              questions. No forms. No waiting.
            </p>
            <p className="font-medium text-deep-teal" data-id="element-103">
              We're not asking you to trust us. We're asking you to try it
              tonight and let your body decide.
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 pt-8 border-t border-gold/20" data-id="element-104">
            {['30-Day Money Back Guarantee', 'No Questions Asked', 'Instant Refund Process'].map((text, i) => <div key={i} className="flex items-center gap-2" data-id="element-105">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gold/20 flex items-center justify-center" data-id="element-106">
                  <Check className="w-3.5 h-3.5 text-deep-teal" strokeWidth={3} data-id="element-107" />
                </div>
                <span className="text-sm md:text-base font-medium text-gray-800" data-id="element-108">
                  {text}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>

      {/* Bottom transition to match OfferBlock's white wave expectation */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-b from-transparent to-white pointer-events-none" data-id="element-109"></div>
    </section>;
}